import { render } from "./ViewDataHasilWawancaraOrtu.vue?vue&type=template&id=4bef3766"
import script from "./ViewDataHasilWawancaraOrtu.vue?vue&type=script&lang=js"
export * from "./ViewDataHasilWawancaraOrtu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__